import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { InputDadosModelView, OutputDadosModelView} from '../model/transmissao-arquivo-ipm.model';
import { BaseConfig } from '../../../../shared/service/base-config.service';
import { GenericHttpService } from '../../../../shared/service/generic-http.service';


@Injectable()

export class TransmissaoArquivoIpmService {
  
  private readonly urlBase: string;

  constructor(
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public DadosOnInitFormulario (): Observable<OutputDadosModelView> {
    let retorno: Observable<OutputDadosModelView> = null;
    retorno = this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/ipm/TransmissaoArquivoIpm/DadosOnInitFormulario'), null);
    return retorno;
  }

  public TransmitirArquivoIpm(filtro : FormData): Observable<any> {

    let retorno: Observable<any> = null;
    retorno = this.http.UploadArquivo(this.baseConfig.getBaseUrlApi().concat('/ipm/TransmissaoArquivoIpm/TransmitirArquivoIpm'), filtro);
    return retorno;
  }

  public ValidaTransmitirArquivoIpm(filtro : FormData): Observable<any> {

    let retorno: Observable<any> = null;
    retorno = this.http.UploadArquivo(this.baseConfig.getBaseUrlApi().concat('/ipm/TransmissaoArquivoIpm/ValidaStatus'), filtro);
    return retorno;
  }

}


// WEBPACK FOOTER //
// ./src/app/ipm/transmissao-arquivo-ipm/shared/service/transmissao-arquivo-ipm.service.ts